import {observable, computed, action, autorun, reaction, runInAction, toJS} from 'mobx';
import queryString from 'query-string';
import urlParse from 'url-parse';

import {getIn} from '../utils';

export class VFinished{
  @observable paymentType;
  @observable confirmationContent = {};
  @observable trxId;
  @observable message;

  constructor(flasher, api, navigation, organization, rentalTransaction, rentalObject, businessUnit, vBookingWizard, vReview,
      personalDataForm, personalAddressForms) {
    this.flasher = flasher;
    this.api = api;
    this.navigation = navigation;
    this.organization = organization;
    this.rentalTransaction = rentalTransaction;
    this.rentalObject = rentalObject;
    this.businessUnit = businessUnit;
    this.vBookingWizard = vBookingWizard;
    this.vReview = vReview;
    this.personalDataForm = personalDataForm;
    this.personalAddressForms = personalAddressForms;
  }

  @computed get objectName() {
    return getIn(this.confirmationContent, ['RentalTransaction', 0, 'Name']);
  }

  @computed get bookingStartDate() {
    return getIn(this.confirmationContent, ['RentalTransaction', 0, 'PickupStartDate']);
  }

  @computed get bookingEndDate() {
    return getIn(this.confirmationContent, ['RentalTransaction', 0, 'DropoffEndDate']);
  }

  @computed get bookingPrice() {
    return getIn(this.confirmationContent, ['RentalTransaction', 0, 'TotalDiscountedPrice']);
  }

  @computed get isGuestTransaction() {
    return getIn(this.confirmationContent, ['RentalTransaction', 0, 'IsGuestTransaction'], "false") === "true";
  }

  async startOrUpdate(state) {
    this.vBookingWizard.setVisitedStep(7);
    this.vReview.reset();
    this.orgId = state.orgId;
    this.trxId = state.trxId;
    this.message = state.message;

    this.personalDataForm.reset({
      salutation: '',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      oldPassword: '',
      password1: '',
      password2: '',
    });
    this.personalAddressForms.forEach(o => {
      o.reset({
        street: '',
        addition: '',
        postalCode: '',
        city: '',
        country: '',
      })
    }); 
    
    
    try {
      this.flasher.setOther('Loading.')
      this.confirmationContent = {};
      this.confirmationContent = await this.api.getConfirmation({trxId: this.trxId});
    }
    catch(e) {
      this.flasher.handleError(e);
    }
    finally {
      this.flasher.setOther()      
    }
  }

  stop() { 
  }
} 


// WEBPACK FOOTER //
// ./src/view/VFinished.js